<template>
	<div>
		<div class="tabBar">
			<div class="tab" @click="toPage(0)">
				<div>
					<img v-if="selected == 0" :src="tabs[0].activeImg" />
					<img v-else :src="tabs[0].img" />
				</div>
				<div :class="{'activeColor':selected == 0}">{{tabs[0].text}}</div>
			</div>
			<div class="tab" @click="toPage(1)">
				<div>
					<img v-if="selected == 1" :src="tabs[1].activeImg" />
					<img v-else :src="tabs[1].img" />
				</div>
				<div :class="{'activeColor':selected == 1}">{{tabs[1].text}}</div>
			</div>
			<div class="tab" @click="toPage(2)">
				<div>
					<img v-if="selected == 2" :src="tabs[2].activeImg" />
					<img v-else :src="tabs[2].img" />
				</div>
				<div :class="{'activeColor':selected == 2}">{{tabs[2].text}}</div>
			</div>
		</div>

		<transition name="van-fade" mode="out-in">
		<keep-alive include="Index,Merchant,Mine">
			<router-view />
		</keep-alive>
		</transition>
	</div>
</template>


<script>
	export default {
		data() {
			return {
				selected: 0,
				tabs: [
					{
						text: "首页",
						path: "/main/index",
						img: require("@/assets/tabbar/tab-home.png"),
						activeImg: require("@/assets/tabbar/tab-home-active.png")
					},
					{
						text: "商家",
						path: "/main/merchant",
						img: require("@/assets/tabbar/tab-merchant.png"),
						activeImg: require("@/assets/tabbar/tab-merchant-active.png")
					},
					{
						text: "我的",
						path: "/main/mine",
						img: require("@/assets/tabbar/tab-mine.png"),
						activeImg: require("@/assets/tabbar/tab-mine-active.png")
					}
				]
			};
		},
		created() {
			this.updateTabBarState()
			window.addEventListener('popstate', this.handlePopstate)
		},
		destroyed() {
			window.removeEventListener('popstate', this.handlePopstate)
		},
		watch: {
			'$route.path': {
				immediate: true,
				handler() {
					this.updateTabBarState()
				}
			}
		},
		methods: {
			handlePopstate() {
				this.updateTabBarState()
			},
			toPage(index) {
				const tab = this.tabs[index]
				if (this.selected !== index) {
					this.$router.push({ path: tab.path })
					this.selected = index
				}
			},
			updateTabBarState() {
				const currentPath = this.$route.path
				const index = this.tabs.findIndex(tab => currentPath === tab.path)
				this.selected = index >= 0 ? index : 100
			}
		},
		activated() {
			this.updateTabBarState()
		}
	};
</script>

<style scoped>
	.tabBar {
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		width: 100%;
		background-color: #fff;
		height: 48px;
	}

	.tabBar .tab {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		height: 48px;
	}

	.tabBar .tab div:nth-child(2) {
		font-size: 12px;
	}

	.tabBar .tab div:nth-child(1) {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 20px;
		height: 20px;
	}

	.tabBar .tab div img {
		width: 20px;
		height: 20px;
	}

	.activeColor {
		color: #E73823;
	}

	.router-fade-enter-active,
	.router-fade-leave-active {
		transition: opacity 0.3s;
	}

	.router-fade-enter,
	.router-fade-leave-active {
		opacity: 0;
	}
</style>